import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
  ASSET_FOUND_ELSEWHERE_GET_FAILURE: "ASSET_FOUND_ELSEWHERE_GET_FAILURE",
  ASSET_FOUND_ELSEWHERE_GET_REQUEST: "ASSET_FOUND_ELSEWHERE_GET_REQUEST",
  ASSET_FOUND_ELSEWHERE_GET_SUCCESS: "ASSET_FOUND_ELSEWHERE_GET_SUCCESS",
  ASSET_FOUND_ELSEWHERE_ACCEPT_FAILURE: "ASSET_FOUND_ELSEWHERE_ACCEPT_FAILURE",
  ASSET_FOUND_ELSEWHERE_ACCEPT_REQUEST: "ASSET_FOUND_ELSEWHERE_ACCEPT_REQUEST",
  ASSET_FOUND_ELSEWHERE_ACCEPT_SUCCESS: "ASSET_FOUND_ELSEWHERE_ACCEPT_SUCCESS",
};

export const actionCreators = {
  getRequest: (auditId: number) => ({
    type: actionTypes.ASSET_FOUND_ELSEWHERE_GET_REQUEST,
    payload: { auditId },
    [WAIT_FOR_ACTION]: actionTypes.ASSET_FOUND_ELSEWHERE_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.ASSET_FOUND_ELSEWHERE_GET_FAILURE
  }),
  getSuccess: (assetFoundElsewhere: Array<any>) => ({
    type: actionTypes.ASSET_FOUND_ELSEWHERE_GET_SUCCESS,
    payload: { assetFoundElsewhere }
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.ASSET_FOUND_ELSEWHERE_GET_FAILURE,
    error
  }),
  acceptRequest: (auditId: number, altAsset: number, expectedAsset: number) => ({
    type: actionTypes.ASSET_FOUND_ELSEWHERE_ACCEPT_REQUEST,
    payload: { auditId, altAsset, expectedAsset },
    [WAIT_FOR_ACTION]: actionTypes.ASSET_FOUND_ELSEWHERE_ACCEPT_SUCCESS,
    [ERROR_ACTION]: actionTypes.ASSET_FOUND_ELSEWHERE_ACCEPT_FAILURE
  }),
  acceptSuccess: (auditId: number) => ({
    type: actionTypes.ASSET_FOUND_ELSEWHERE_ACCEPT_SUCCESS,
    payload: { auditId }
  }),
  acceptFailure: (error: Error) => ({
    type: actionTypes.ASSET_FOUND_ELSEWHERE_ACCEPT_FAILURE,
    error
  }),
};

export default {
  create: actionCreators,
  type: actionTypes
};
